import { ScoRegistry } from "@/scorm/common/ScoRegistry";
import { Sco2004Data, LESSON_LOCATION_MODEL_ID, SCORE_MODEL_ID, SUCCESS_STATUS_MODEL_ID } from "@/scorm/scorm_1_3/Sco2004Data";
export function createCourseLessons() {
    const scoRegistry = new ScoRegistry(Sco2004Data);
    return {
        initialize: (suspendData) => scoRegistry.initialize(suspendData),
        contains: (lessonId) => scoRegistry.contains(lessonId),
        create: (lessonId) => {
            scoRegistry.initializeNewSco(lessonId);
            scoRegistry.setValue(lessonId, "lesson_id", lessonId);
        },
        getLesson: (lessonId) => {
            if (scoRegistry.contains(lessonId)) {
                return createLessonFacade(Number(scoRegistry.getValue(lessonId, SCORE_MODEL_ID)), scoRegistry.getValue(lessonId, SUCCESS_STATUS_MODEL_ID), scoRegistry.getValue(lessonId, LESSON_LOCATION_MODEL_ID));
            }
            return createLessonFacade(0, null, "");
        },
        getLessonData: (lessonId) => scoRegistry.get(lessonId),
        setRelevantScoList: (idList) => scoRegistry.setRelevantScoList(idList),
        getStatusForResultRelevantScos: () => scoRegistry.getStatusForResultRelevantScos(),
        collectSuspendData: () => scoRegistry.collectSuspendData(),
        getLessonValue: (lessonId, scormModelId) => {
            return scoRegistry.getValue(lessonId, scormModelId);
        },
        setLessonValue: (lessonId, scormModelId, value) => {
            console.log(`lesson id: ${lessonId}, "${scormModelId}" = "${value}"`);
            scoRegistry.setValue(lessonId, scormModelId, value);
        }
    };
}
function createLessonFacade(score, status, location) {
    return {
        getScore: () => score,
        getStatus: () => status,
        getLocation: () => location,
        canResume: () => location.length > 0
    };
}
